

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmationDialogProgrammatic extends Vue {
    @Prop({ type: String, default: 'Are You Sure?' }) public title!: string;
    @Prop({ type: String, default: 'primary' }) public variant!: string;
    @Prop({ type: Boolean, default: false }) public showCancel!: boolean;
    @Prop({ type: Boolean, default: false }) public showContinue!: boolean;
    @Prop({ type: String, default: 'OK' }) public okText!: string;
    @Prop({ type: String, default: 'Cotinue' }) public continueText!: string;
    @Prop({ type: String, default: 'Cancel' }) public cancelText!: string;
    @Prop({ type: String, default: 'Are you sure?' }) public message!: string;
    @Prop({ type: Function, default: () => { } }) public onOk!: () => {};
    @Prop({ type: Function, default: () => { } }) public onContinue!: () => {};
    @Prop({ type: Function, default: () => { } }) public onCancel!: () => {};

    private isVisible: boolean = true;

    private handleOk(): void {
        this.onOk();
        this.close();
    }

    private handleContinue(): void {
        this.onContinue();
        this.close();
    }

    private handleCancel(e: any): void {
        this.onCancel();
        this.close();
    }

    private close(): void {
        this.isVisible = false;
        setTimeout(() => {
            this.$destroy();
            this.removeElement(this.$el);
        }, 150);
    }

    private removeElement(el: Element) {
        if (el.remove !== undefined) {
            el.remove();
        } else if (el.parentNode !== undefined && el.parentNode !== null) {
            el.parentNode.removeChild(el);
        }
    }

    public beforeMount(): void {
        this.$nextTick(() => {
            document.body.appendChild(this.$el);
        });
    }

    public mounted(): void {
        this.isVisible = true;
    }
}
